var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSynapseSource = function SvgSynapseSource(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    viewBox: "0 0 132.292 132.292",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillOpacity: 1,
    strokeDasharray: "none",
    strokeMiterlimit: 4,
    strokeOpacity: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 83.831,
    cy: 123.284,
    r: 2.272,
    fill: "#3b96d9",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.058,
    transform: "rotate(-6.784)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92.516,
    cy: 129.788,
    r: 2.272,
    fill: "#3b96d9",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.058,
    transform: "rotate(-6.784)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.32,
    cy: 134.948,
    r: 2.272,
    fill: "#3b96d9",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.058,
    transform: "rotate(-6.784)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b7b6ca",
    stroke: "#000",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeWidth: 1.975,
    d: "M63.94.674l-.003.015L46.942.82C44.151 31.119 43.891 41.15 20.03 61.378 6.135 75.069 8.625 96.283 21.997 108.972c.98.333 1.97.651 2.97.957a8.356 8.356 0 018.13-6.425 8.356 8.356 0 018.355 8.355 8.356 8.356 0 01-.2 1.816 145.9 145.9 0 004.736.7 8.356 8.356 0 018.343-7.909 8.356 8.356 0 018.356 8.356 8.356 8.356 0 01-.032.723c.893.002 1.76-.007 2.59-.028.959.015 1.95.012 2.955 0a8.356 8.356 0 01-.002-.2 8.356 8.356 0 018.355-8.357 8.356 8.356 0 018.28 7.231c1.4-.2 2.825-.424 4.272-.674a8.356 8.356 0 01-.167-1.658 8.356 8.356 0 018.356-8.356 8.356 8.356 0 018.099 6.302 167.07 167.07 0 002.85-.833c13.372-12.689 16.422-35.967 1.469-47.719C85.85 41.026 85.662 31.12 82.87.821L65.876.689l-.004-.015-.966.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b7b6ca",
    stroke: "none",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.995,
    d: "M48.074-1.938h33.77l.601 10.14-35.072-.134z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.139,
    cy: 88.468,
    r: 9.132,
    fill: "#d7d7d7",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.852
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.656,
    cy: 90.584,
    r: 9.132,
    fill: "#d7d7d7",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.852
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92.643,
    cy: 88.468,
    r: 9.132,
    fill: "#d7d7d7",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.852
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.943,
    cy: 63.597,
    r: 9.132,
    fill: "#d7d7d7",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.852
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.427,
    cy: 63.597,
    r: 9.132,
    fill: "#d7d7d7",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.852
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#3b96d9",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.058
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 51.155,
    cy: 59.792,
    r: 2.272
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.698,
    cy: 65.272,
    r: 2.272
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.155,
    cy: 66.602,
    r: 2.272
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#3b96d9",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.058
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 78.671,
    cy: 59.792,
    r: 2.272
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.215,
    cy: 65.272,
    r: 2.272
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.672,
    cy: 66.602,
    r: 2.272
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#3b96d9",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.058
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 91.371,
    cy: 84.663,
    r: 2.272
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.915,
    cy: 90.142,
    r: 2.272
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.372,
    cy: 91.473,
    r: 2.272
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#3b96d9",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.058
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 64.384,
    cy: 86.78,
    r: 2.272
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.927,
    cy: 92.259,
    r: 2.272
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.385,
    cy: 93.59,
    r: 2.272
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#3b96d9",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.058
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36.867,
    cy: 84.663,
    r: 2.272
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.411,
    cy: 90.142,
    r: 2.272
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.868,
    cy: 91.473,
    r: 2.272
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 76.766,
    cy: 89.304,
    r: 2.272,
    fill: "#3b96d9",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.058,
    transform: "rotate(24.646)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.375,
    cy: 96.747,
    r: 2.272,
    fill: "#3b96d9",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.058,
    transform: "rotate(24.646)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.868,
    cy: 101.767,
    r: 2.272,
    fill: "#3b96d9",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.058,
    transform: "rotate(24.646)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80.922,
    cy: 99.597,
    r: 2.272,
    fill: "#3b96d9",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.058,
    transform: "rotate(14.162)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.45,
    cy: 107.89,
    r: 2.272,
    fill: "#3b96d9",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.058,
    transform: "rotate(14.162)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.388,
    cy: 108.977,
    r: 2.272,
    fill: "#3b96d9",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.058,
    transform: "rotate(14.162)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.877,
    cy: 109.601,
    r: 2.272,
    fill: "#3b96d9",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.058,
    transform: "rotate(4.135)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.459,
    cy: 119.563,
    r: 2.272,
    fill: "#3b96d9",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.058,
    transform: "rotate(4.135)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81.975,
    cy: 118.599,
    r: 2.272,
    fill: "#3b96d9",
    stroke: "#000",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.058,
    transform: "rotate(4.135)"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSynapseSource);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/synapse-source.9302ff90a71db70ade3ed655e18ba817.svg";